import { PureComponent } from "react";

import yup from "utilities/form/yup";
import { getAccuracy } from "utilities/number/number";

import { BTInputNumber } from "commonComponents/btWrappers/BTInputNumber/BTInputNumber";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
    type IGridFilterCellRenderProps,
} from "commonComponents/utilities/Grid/GridContainer.types";
import { NumberDisplay } from "commonComponents/utilities/NumberDisplay/NumberDisplay";

interface INumberResponse {
    value: number | undefined;
    scale: number;
}

class NumberFilterCell extends PureComponent<
    IGridFilterCellRenderProps<INumberResponse | undefined>
> {
    private handleChange = (field: string, value: number | null | undefined) => {
        const { cellValue, onChange } = this.props;
        onChange(field, { precision: 0, ...cellValue, value });
    };
    render() {
        const { cellValue, field } = this.props;
        return (
            <BTInputNumber<undefined>
                min={-Infinity}
                max={Infinity}
                id={field.full}
                data-testid={field.full}
                value={cellValue ? cellValue.value : undefined}
                precision={cellValue ? cellValue.scale : undefined}
                onChange={this.handleChange}
            />
        );
    }
}

class NumberCell extends PureComponent<IGridCellRenderProps<INumberResponse | undefined>> {
    render() {
        const { cellValue } = this.props;
        return cellValue && cellValue.value ? (
            <NumberDisplay
                value={cellValue.value}
                decimalScale={Math.max(0, getAccuracy(cellValue.value))}
            />
        ) : null;
    }
}

export const columnNumber: IClientGridColumn<INumberResponse | undefined> = {
    validationSchema: yup.object<INumberResponse>({
        value: yup.number(),
        scale: yup.number(),
    }),
    columnType: GridColumnType.number,
    FilterCell: NumberFilterCell,
    Cell: NumberCell,
};
